import { render } from "./App.vue?vue&type=template&id=362c5ce4&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=362c5ce4&lang=scss"

import exportComponent from "C:\\Users\\AnisAjengui\\Desktop\\anis-work\\code\\sav-menzzo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__